import * as scrollToElement from 'scroll-to-element';
var toggleContentLoader = /** @class */ (function () {
    function toggleContentLoader() {
        this.toggleContentClassName = 'js-toggle-content';
        var toggleContent = document.getElementsByClassName(this.toggleContentClassName);
        for (var i = 0; i < toggleContent.length; i++) {
            new ToggleContent(toggleContent[i]);
        }
    }
    return toggleContentLoader;
}());
export default toggleContentLoader;
var ToggleContent = /** @class */ (function () {
    function ToggleContent(toggleContent) {
        this.hideClassName = 'u-hide';
        this.toggleContentTextSelector = '.js-toggle-content-text';
        this.showMoreText = 'mehr';
        this.showLessText = 'weniger';
        this.initialized = false;
        this.toggleContent = toggleContent;
        this.toggleContentText = this.setContentTextElement();
        this.shortText = this.setElementShortText();
        this.longText = this.setElementLongText();
        this.showMoreTextTranslated = this.toggleContent.getAttribute('data-toggle-label-more') ? this.toggleContent.getAttribute('data-toggle-label-more') : this.showMoreText;
        this.showLessTextTranslated = this.toggleContent.getAttribute('data-toggle-label-less') ? this.toggleContent.getAttribute('data-toggle-label-less') : this.showLessText;
        var elementToToggle = this.setElementToToggle();
        if (elementToToggle) {
            this.bindEvents(elementToToggle);
        }
    }
    ToggleContent.prototype.scrollToElementFunc = function () {
        var target = this.toggleContent.getAttribute('data-scroll-target') || '';
        if (target) {
            var scrollElement = document.getElementById(target);
            if (scrollElement) {
                scrollToElement(scrollElement, {
                    align: 'middle'
                });
            }
        }
    };
    ToggleContent.prototype.bindEvents = function (element) {
        var _this = this;
        this.toggleContent.addEventListener('click', function () {
            _this.toggle(element);
        });
    };
    ToggleContent.prototype.isVisible = function (element) {
        return element.classList.contains(this.hideClassName);
    };
    ToggleContent.prototype.setContentText = function (text) {
        if (this.toggleContentText) {
            this.toggleContentText.innerText = text;
        }
    };
    ToggleContent.prototype.setContentTextElement = function () {
        return this.toggleContent.querySelector(this.toggleContentTextSelector);
    };
    ToggleContent.prototype.setElementToToggle = function () {
        var id = this.toggleContent.getAttribute('data-toggle-id') || '';
        return document.getElementById(id) || null;
    };
    ToggleContent.prototype.setElementShortText = function () {
        var id = this.toggleContent.getAttribute('data-short-text-id') || '';
        return document.getElementById(id) || null;
    };
    ToggleContent.prototype.setElementLongText = function () {
        var id = this.toggleContent.getAttribute('data-long-text-id') || '';
        return document.getElementById(id) || null;
    };
    ToggleContent.prototype.show = function (element) {
        element.classList.add(this.hideClassName);
        if (this.shortText) {
            this.shortText.classList.remove(this.hideClassName);
        }
        if (this.longText) {
            this.longText.classList.add(this.hideClassName);
        }
        this.setContentText(this.showMoreTextTranslated);
        this.scrollToElementFunc();
    };
    ToggleContent.prototype.hide = function (element) {
        element.classList.remove(this.hideClassName);
        if (this.shortText) {
            this.shortText.classList.add(this.hideClassName);
        }
        if (this.longText) {
            this.longText.classList.remove(this.hideClassName);
        }
        this.setContentText(this.showLessTextTranslated);
    };
    ToggleContent.prototype.toggle = function (element) {
        this.isVisible(element) ? this.hide(element) : this.show(element);
    };
    return ToggleContent;
}());
export { ToggleContent };
